import { useEffect, useRef } from "react";

export default function TradingViewWidget({ symbol, interval }) {
  const box = useRef(null);
  useEffect(() => {
    const el = box.current;
    const inner = document.createElement("div");
    inner.className = "tradingview-widget-container__widget";
    inner.style.cssText = "height:100%;width:100%";
    const s = document.createElement("script");
    s.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    s.async = true;
    s.text = JSON.stringify({
      autosize: true,
      symbol,
      interval: { "15m": "15", "1h": "60", "4h": "240", "1d": "D" }[interval],
      theme: "dark",
      style: "1",
      backgroundColor: "#0F141C",
      gridColor: "rgba(30, 39, 56, 0.6)",
      allow_symbol_change: true,
      hide_side_toolbar: false,
      support_host: "https://www.tradingview.com",
    });
    el.replaceChildren(inner, s);
    return () => el.replaceChildren();
  }, [symbol, interval]);
  return <div ref={box} className="tradingview-widget-container h-[460px] w-full" data-testid="tradingview-widget" />;
}
